define('views/base/list_view',['require','backbone'],function(require){

    var Backbone = require('backbone');

    return Backbone.Marionette.CompositeView.extend({
        childViewContainer: 'tbody',
        searchTimeout: null,
        fetchTrigger: null,

        initialize: function () {
            this.listenTo(this.collection, 'fetch_complete', this._onFetch);
            this.collection.fetch();
        },

        ui: function() {
            return {
                pageLink: '.page-link',
                tableHeader: 'thead',
                colHeader: 'thead th'
            };
        },

        events: {
            'click @ui.pageLink': 'pageLinkClicked',
            'click @ui.colHeader': 'colHeaderClicked'
        },

        templateHelpers: function() {
            return {
                collection: this.collection,
                pageCount: parseInt(this.collection.total / this.collection.limit) + 1,
                currentPage: parseInt(this.collection.offset / this.collection.limit) + 1,
                pages: this.getPages()
            };
        },

        getPages: function () {
            var currentPage = parseInt(this.collection.offset / this.collection.limit) + 1;
            var pageCount = parseInt(this.collection.total / this.collection.limit) + 1;

            var pages = [];

            var start = (currentPage - 2) > 0 ? (currentPage - 2) : 1;
            var end = (currentPage + 2) <= pageCount ? (currentPage + 2) : pageCount;

            for (var i=start; i<=end; i++) {
                pages.push(i);
            }

            return pages;
        },

        pageLinkClicked: function (e) {
            var clickedLink = $(e.currentTarget);
            var pageNumber = parseInt(clickedLink.attr('data-page'));
            var currentPage = parseInt(this.offset / this.limit) + 1;

            if (pageNumber < 1) {
                pageNumber = 1;
            }

            if (this.collection.total) {
                var pageCount = parseInt(this.collection.total / this.collection.limit) + 1;

                if (pageNumber > pageCount) {
                    pageNumber = pageCount;
                }
            }

            if (currentPage != pageNumber) {
                this.collection.changePage(pageNumber);
                this.collection.fetch();
            }
        },

        colHeaderClicked: function (e) {
            
            var clickedHeader = $(e.currentTarget);
            var field = clickedHeader.attr('data-field');

            if (field) {
                if (field == this.collection.ordering) {
                    this.collection.changeOrdering('-' + field);
                } else if (('-' + field) == this.collection.ordering) {
                    this.collection.changeOrdering('');
                } else {
                    this.collection.changeOrdering(field);
                }

                this.collection.fetch();
            }

        },

        _onFetch: function () {
            this.render();
        }
    });
});
